import "./sideBar.css";
import { useGlobalContext } from "../../../Context/Context";
import { useEffect, useRef, useState } from "react";
import Button from "../../Custom/Button/Button";
import backIcon from "../../picture/Back.png";
import leftIcon from "../../picture/play-left.png";
import rightIcon from "../../picture/play-right.png";
import cancelIcon from "../../picture/cancel.png";
import extendIcon from "../../picture/extend.png";

const SideBar = ({
  renderContent,
  currentTab,
  setCurrentTab,
  slideButton,
  setSlideButton,
  setSpeakerButton,
  setLanguageButton,
  speakerButton,
  languageButton,
  checkBack,
  setCheckBack,
  sideBarRef
}) => {
  const {
    activeIcons,
    setActiveIcons,
    setActiveIconsMiddleAdmin,
    activeIconsMiddleAdmin,
    activeStates,
    setActiveStates
  } = useGlobalContext();

  const sideBarWrapperRef = useRef();
  const slideBarSlideRef = useRef();
  const slideBarIconsRef = useRef();
  const slideBarIconRef = useRef();
  const maxLeftRef = useRef();

  const [currentActiveIcon, setCurrentActiveIcon] = useState(
    activeIcons.length !== 0 ? activeIcons[activeIcons.length - 1] : null
  );
  const [showArrow, setShowArrow] = useState({
    left: false,
    right: false,
    value: 1
  });

  const { currentChatAdmin, setCurrentChatAdmin } = useGlobalContext();

  const handleChangeIcon = (icon) => {
    if (icon.name === currentActiveIcon?.name) return;
    setCurrentTab(icon.name);
    setCurrentActiveIcon(icon);
  };

  const handleBack = () => {
    if (checkBack) {
      setCurrentChatAdmin(null);
      setCheckBack(false);
    }
  };

  const handleCancel = () => {
    const newSlideButton = slideButton.map((item) => {
      if (item.active > 0) {
        return { ...item, active: 0 };
      }
      return item;
    });

    const newSpeakerButton = speakerButton.map((item) => {
      if (item.active > 0) {
        return { ...item, active: 0 };
      }
      return item;
    });

    const newLanguagerButton = languageButton.map((item) => {
      if (item.active > 0) {
        return { ...item, active: 0 };
      }
      return item;
    });

    setSlideButton(newSlideButton);
    setSpeakerButton(newSpeakerButton);
    setLanguageButton(newLanguagerButton);
    setActiveIcons([]);
    setCurrentTab(null);
    setActiveIconsMiddleAdmin([]);
    setActiveStates([]);
    setCurrentChatAdmin(null);
  };

  const handleClickViewDocument = () => {
    console.log("current tab", currentTab);
    if (currentChatAdmin === null && currentTab === "MESSAGES") return;

    // azuriranje niza aktivnih ikona u glavnom delu taskbara -> napravi posebnu fju u context-u za ovo
    let newMiddleIcon = activeIconsMiddleAdmin.find(
      (icon) => icon.name === currentTab
    );
    if (newMiddleIcon === undefined) {
      setActiveIconsMiddleAdmin([
        ...activeIconsMiddleAdmin,
        {
          name: currentTab,
          data: currentChatAdmin
        }
      ]);
    } else {
      const newActiveIcons = activeIconsMiddleAdmin.map((icon) => {
        if (icon.name === currentTab) {
          return {
            name: currentTab,
            data: currentChatAdmin
          };
        } else return icon;
      });
      setActiveIconsMiddleAdmin(newActiveIcons);
    }
  };

  const handleChange = (cond) => {
    let currentIndex = activeIcons
      .map((icon) => icon.name)
      .indexOf(currentActiveIcon.name);
    if (cond && currentIndex === activeIcons.length - 1) return;
    if (!cond && currentIndex === 0) return;

    const correctIcon = activeIcons[cond ? currentIndex + 1 : currentIndex - 1];

    setCurrentActiveIcon(correctIcon);
    setCurrentTab(correctIcon.name);
  };

  const check = () => {
    if (currentTab === "SPEAKER") return false;
    if (currentTab === "LANGUAGE") return false;

    return true;
  };

  const handleLeftArrow = () => {
    /* console.log(slideBarIconsRef.current.getBoundingClientRect().left);

    if (
      slideBarIconsRef.current.getBoundingClientRect().right >
      sideBarWrapperRef.current.getBoundingClientRect().right
    ) {
      const translateWidth =
        slideBarIconsRef.current.getBoundingClientRect().height;
      slideBarIconsRef.current.style.transform = `translateX(${translateWidth}px)`;

      setShowArrow({ ...showArrow, right: true });
    } else {
      setShowArrow({ ...showArrow, left: false });
    }*/
    const iconsDim = slideBarIconsRef.current.getBoundingClientRect();
    const wrapperDim = sideBarWrapperRef.current.getBoundingClientRect();
    const currentTranslateX = Math.abs(
      maxLeftRef.current - (iconsDim.right - wrapperDim.right)
    );
    const newTranslateX = currentTranslateX + iconsDim.height;
    slideBarIconsRef.current.style.transform = `translateX(${newTranslateX}px)`;
    console.log(maxLeftRef.current);
    console.log(newTranslateX);
    console.log(maxLeftRef.current >= 0);

    if (maxLeftRef.current - maxLeftRef.current >= 0) {
      setShowArrow({ left: false, right: true });
      console.log("sdasd");
    } else {
      setShowArrow({ left: true, right: true });
    }
  };

  const handleRightArrow = () => {
    /*console.log(
      slideBarIconsRef.current.getBoundingClientRect().right,
      parseInt(slideBarIconsRef.current.getBoundingClientRect().width / 7) *
        (activeIcons.length - 7)
    );
    const sliderIconsDim = slideBarIconsRef.current.getBoundingClientRect();
    console.log(sliderIconsDim.right);
    const sliderWrapperDim = sideBarWrapperRef.current.getBoundingClientRect();
    console.log(sliderWrapperDim.right);
    if (sliderIconsDim.right > sliderWrapperDim.right) {
      const translateWidth = sliderIconsDim.right - sliderIconsDim.height;
      slideBarIconsRef.current.style.transform = `translateX(${-translateWidth}px)`;
      setShowArrow({ ...showArrow, left: true });
    } else setShowArrow({ ...showArrow, right: false });*/
    const iconsDim = slideBarIconsRef.current.getBoundingClientRect();
    const wrapperDim = sideBarWrapperRef.current.getBoundingClientRect();
    const currentTranslateX = Math.abs(
      maxLeftRef.current - (iconsDim.right - wrapperDim.right)
    );
    const newTranslateX = currentTranslateX - iconsDim.height;
    slideBarIconsRef.current.style.transform = `translateX(${newTranslateX}px)`;
    console.log(newTranslateX);
    if (0 === Math.round(newTranslateX))
      setShowArrow({ left: true, right: false });
    else setShowArrow({ left: true, right: true });
  };

  useEffect(() => {
    /*console.log("Menja se stanje aktivnih stat-a");
    if (activeIcons.length > 7) {
      setShowArrow({ left: true, right: false });
      console.log(
        slideBarIconsRef.current.getBoundingClientRect().left,
        sideBarWrapperRef.current.getBoundingClientRect().left
      );

      
      const translateWidth =
        slideBarIconsRef.current.getBoundingClientRect().height *
        (activeIcons.length - 7);
      console.log(translateWidth);
      slideBarIconsRef.current.style.transform = `translateX(-${translateWidth}px)`;
    
    } else {
      setShowArrow({ left: false, right: false });
    }*/
    if (activeIcons.length !== 0) {
      console.log("ajiosnoijas");
      const iconsDim = slideBarIconsRef.current.getBoundingClientRect();
      const wrapperDim = sideBarWrapperRef.current.getBoundingClientRect();
      maxLeftRef.current = iconsDim.right - wrapperDim.right;
      if (activeIcons.length > 7) setShowArrow({ left: true, right: false });
      else setShowArrow({ left: false, right: false });
      const sidebarIcons = document.querySelectorAll(".sidebar-icon");
      if (sidebarIcons.length > 0)
        sidebarIcons[sidebarIcons.length - 1].scrollIntoView();
      slideBarIconsRef.current.style.transform = "translateX(0px)";
    }
  }, [activeIcons]);

  useEffect(() => {
    let current;
    const currentActiveState = activeStates.find(
      (state) => state.name === currentTab
    );

    console.log("Promena ikona");

    if (currentActiveState !== undefined) {
      setCheckBack(currentActiveState.data.checkBack);
    } else setCheckBack(false);
    const wraperCompanies = document.querySelector(".wraper-companies");
    if (currentTab !== null) {
      wraperCompanies.classList.add("not-scrollable");
      if (
        !(
          currentTab === "SPEAKER" ||
          // currentTab === "FOLDER" ||
          currentTab === "LANGUAGE"
        )
      ) {
        current = activeIcons.find((icon) => icon.name === currentTab);
        setCurrentActiveIcon(current);
      }
    } else {
      wraperCompanies?.classList.remove("not-scrollable");
      current = null;
      setCurrentActiveIcon(current);
    }

    console.log("skroluje ikone", activeIcons, currentTab);
  }, [currentTab]);

  const setDimensions = () => {
    const buttonCompany = document.querySelector(".button-taskbar");
    const buttonSlidebarDiv = document.querySelector(".button-picture");
    if (buttonSlidebarDiv) {
      const buttonSlidebar = buttonSlidebarDiv.getBoundingClientRect();
      const sidebar = document.querySelector(".side-bar");
      const taskbar = document.querySelector(".task-bar");
      console.log(sidebar);
      if (sidebar) {
        const btnCompanyDim = buttonCompany.getBoundingClientRect();
        sidebar.style.top = `${btnCompanyDim.height}px`;
        //  sidebar.style.height = `calc(100% - ${btnCompanyDim.height}px)`;
        sidebar.style.width = `${buttonSlidebar.width * 2}px`;
      } else {
        const sidebarSlide = document.querySelector(".side-bar-slide");
        if (sidebarSlide) sidebarSlide.style.top = "93%";
      }

      taskbar.style.height = `calc(100% - ${buttonSlidebar * 2}px)`;
    }
  };

  window.addEventListener("resize", setDimensions);
  window.addEventListener("load", setDimensions);

  useEffect(() => {
    if (activeIcons.length !== 0) setDimensions();
    return () => {
      window.removeEventListener("resize", setDimensions);
      window.removeEventListener("load", setDimensions);
    };
  }, [activeIcons, currentTab]);

  if (currentTab !== null) {
    return (
      <div className="side-bar" ref={sideBarRef}>
        <div className="side-bar-frame">
          <div className="sidebar-buttons" onClick={handleBack}>
            <Button active={false} activation={true}>
              <img src={backIcon} alt="" className="sidebar-buttons-img" />
            </Button>
          </div>
          <div className="sidebar-btn" onClick={handleClickViewDocument}>
            <Button active={false} activation={true}>
              <img
                src={extendIcon}
                alt=""
                className="sidebar-buttons-img-extend"
              />
            </Button>
          </div>
          <div className="sidebar-buttons" onClick={() => handleCancel()}>
            <Button active={false} activation={true}>
              <img src={cancelIcon} alt="" className="sidebar-buttons-img" />
            </Button>
          </div>
        </div>
        {check() ? (
          renderContent()
        ) : (
          <div
            style={{ height: "85%", width: "20%", backgroundColor: "#686565" }}
          ></div>
        )}
        <div
          style={showArrow.left ? { display: "flex" } : { display: "none" }}
          className="sidebar-icon-dir left"
          onClick={handleLeftArrow}
        >
          <Button activation={true} image={leftIcon} />
        </div>
        <div className="side-bar-slide" ref={slideBarSlideRef}>
          <div className="sidebar-icons-wrapper" ref={sideBarWrapperRef}>
            <div className="sidebar-icons" ref={slideBarIconsRef}>
              {activeIcons.length !== 0 &&
                activeIcons.map((icon, index) => {
                  return (
                    <div
                      className="sidebar-icon"
                      key={index}
                      onClick={() => handleChangeIcon(icon)}
                      ref={slideBarIconRef}
                    >
                      <Button
                        active={icon.name === currentActiveIcon?.name}
                        image={icon.picture}
                        activation={
                          icon.name === currentActiveIcon?.name ||
                          currentTab === null
                        }
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div
          className="sidebar-icon-dir right"
          style={showArrow.right ? { display: "flex" } : { display: "none" }}
          onClick={handleRightArrow}
        >
          <Button activation={true} image={rightIcon} />
        </div>
      </div>
    );
  } else if (activeIcons.length !== 0) {
    return (
      <div className="side-bar-slide custom">
        {activeIcons.length !== 0 &&
          activeIcons.map((icon, index) => {
            return (
              <div
                className="sidebar-icon"
                key={index}
                onClick={() => handleChangeIcon(icon)}
              >
                <Button
                  active={
                    currentTab !== null && icon.name === currentActiveIcon?.name
                  }
                  image={icon.picture}
                  activation={activeIcons.length < 2}
                />
              </div>
            );
          })}
      </div>
    );
  } else return <></>;
};

export default SideBar;
